import axios from 'axios';
import useAuthStore from '../../store/authStore';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL_ADMIN || 'http://localhost:4000/api/admin',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().clearUser();
    }
    return Promise.reject(error);
  }
);

export const getFeaturedCategories = async (params = {}) => {
  const response = await api.get('/featured-categories', { params });
  return response.data;
};

export const getFeaturedCategoryById = async (id) => {
  const response = await api.get(`/featured-categories/${id}`);
  return response.data;
};

export const createFeaturedCategory = async (formData) => {
  const response = await api.post('/featured-categories', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const updateFeaturedCategory = async ({ id, formData }) => {
  const response = await api.put(`/featured-categories/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const deleteFeaturedCategory = async (id) => {
  const response = await api.delete(`/featured-categories/${id}`);
  return response.data;
};

export default api;